import { get } from "lodash";
import { createSelector } from "reselect";

// -- QUERIES -- //

const limitsQuery = state => get(state, "account.data.limits", null);
const entitiesDataMapQuery = state =>
  get(state, "ephemeralEntities.dataMap", null);

// -- PROPS QUERIES -- //

const projectOwnerFromPropsDataQuery = (state, props) => {
  let projectOwner = get(props, "project.createdBy", null);
  return projectOwner;
};

// -- SELECTORS -- //

export const selectLimits = createSelector(
  [projectOwnerFromPropsDataQuery, limitsQuery],
  (projectOwner, accountLimits) => {
    // Prefer project owner limits
    if (projectOwner && typeof projectOwner === "object") {
      return projectOwner.limits;
    }

    // If project owner limits don't exist return limits for current account
    if (accountLimits) return accountLimits;

    return {};
  }
);
